import { Avatar, Box, Button, Flex, Image, Text } from "@chakra-ui/react";
import iconApproved from "../../assets/images/receiveSalary/check-circle.svg";
import iconCheckRed from "../../assets/images/iconCheckRed.png";
import { RiResetLeftFill } from "react-icons/ri";
import { MdAutorenew, MdPending } from "react-icons/md";


export const formatTableValue = (value, key, submit, id, revert) => {
  switch (key) {
    case "status":
      let content;
      if (value === "PAID") {
        content = (
          <Flex gap={4} w={"max-content"}>
            <Flex
              w={"max-content"}
              alignItems={"center"}
              justifyContent={"center"}
              gap={1}
            >
              <Image src={iconApproved} w={"20px"} />
              <Text color={"var(--color-status-employ)"}>Đã thanh toán</Text>
            </Flex>
          </Flex>
        );
      } else if (value === "PARTIAL") {
        content = (
          <Flex align={"center"} gap={1}>
            <MdAutorenew size={20} color={"var(--color-option-employee-hover)"} />
            <Text
              color={"var(--color-option-employee-hover)"}
              w={"max-content"}
              minW={"max-content"}
              display={"block"}
            >
              Đang thanh toán
            </Text>
          </Flex>
        );
      } else {
        // Trạng thái chưa thanh toán: badge màu vàng, icon hình tròn có 3 chấm
        // (MdPending — dùng thư viện react-icons đã có sẵn), nội dung "Chờ thanh toán".
        content = (
          <Flex gap={4} w={"max-content"}>
            <Flex
              w={"max-content"}
              alignItems={"center"}
              justifyContent={"center"}
              gap={1}
            >
              <MdPending size={20} color={"#E0A400"} />
              <Text color={"#E0A400"}>Chờ thanh toán</Text>
            </Flex>
          </Flex>
        );
      }

      return (
        <Flex gap={"8px"} w={"max-content"}>
          {content}
        </Flex>
      );
    default:
      return <Text>{value}</Text>;
  }
};
